import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import FormationsPage from './pages/FormationsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import RegisterPage from './pages/RegisterPage';
import FormationDetailPage from './pages/FormationDetailPage';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
import GlobalSiteJsonLd from './components/GlobalSiteJsonLd';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GlobalSiteJsonLd />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/formations/:id" element={<FormationDetailPage />} />
          <Route path="/formations" element={<FormationsPage />} />
          <Route path="/a-propos" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/actualites" element={<BlogPage />} />
          <Route path="/inscription" element={<RegisterPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
